import styled from "styled-components";
interface Props {
  showMore: boolean;
}
export const Page = styled.div<Props>`
  padding: 0px 30px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  header {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.secondary70};
    span {
      display: flex;
      align-items: flex-start;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    position: relative;
    width: 100%;
    min-height: 200px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    margin-top: 30px;
    margin-bottom: 30px;
    table {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.secondary100};
      text-align: left;
      table-layout: fixed;
      margin-bottom: 15px;

      th {
        font-weight: 600;
        text-transform: capitalize;
      }
      td {
        text-transform: capitalize;
        margin-bottom: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        svg {
          cursor: pointer;
        }
      }
    }
    .header-conf {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.secondary70};
      width: 100%;
      span {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.secondary100};
        display: flex;
        align-items: center;
        svg {
          margin-left: 5px;
        }
      }
    }
    .main-content {
      position: relative;
      margin-top: 20px;
      width: 100%;
      height: 100%;
      display: flex;
      overflow: hidden;
      flex-direction: column;
      gap: 20px;
      align-items: center;
      .file-section{
        margin: 15px 0px;
        p{
          padding: 0;
          margin: 0;
        }
        span{
          color: ${({ theme }) => theme.colors.primary};
          text-decoration: underline;
          cursor: pointer;
        }
        .file{
          display: flex;
          align-items: center;
          gap: 15px;
        }
      }
      .btn-input {
        min-width: 175px;
        height: 45px;
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.secondary10};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 500;
        border-radius: 8px;
        padding: 5px;
        cursor: pointer;
        input {
          display: none;
        }
      }
      textarea {
        width: 100%;
        height: 250px;
        border: 1px solid ${({ theme }) => theme.colors.secondary100};
        border-radius: 8px;
        padding: 10px;
      }
      h2 {
        font-size: 18px;
        color: ${({ theme }) => theme.colors.secondary70};
      }
      .header-main-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .search {
          cursor: pointer;
          margin-top: 30px;
          border-radius: 8px;
          background-color: ${({ theme }) => theme.colors.secondary10};
          box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          width: 45px;
          height: 45px;
          border-radius: 8px;
          align-self: end;
          transition: width 0.4s;
          padding: 11px;

          svg {
            color: ${({ theme }) => theme.colors.secondary100};
            width: 25px;
            height: 25px;
          }
          input {
            display: none;
            margin-right: 8px;
            width: 100%;
            background: transparent;
          }
        }
        .active {
          padding: 14px;
          width: 400px;
          justify-content: end;
          input {
            display: block;
          }
        }
      }
    }
    .tutor {
      height: ${({ showMore }) => (showMore ? "700px" : "160px")};
      transition: height 0.6s;
      gap: 10px;
      align-items: flex-start;
      b {
        font-weight: 500;
      }
      h3 {
        font-size: 16px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.secondary100};
      }
    }
    button {
      margin-top: 15px;
      
    }
  }
`;
